//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function () {
    return {
      items: [],
      search: "",
      isOpen: false,
      isLoading: true,
    }
  },

  props: {
    country: {
      type: Object,
      default: null
    },
    service: {
      type: Object,
      default: null
    },
  },

  computed: {
    searchList: function () {
      const search = String(this.search || '').toLowerCase();
      if (!search) {
        return this.items
      }
      return [...this.items].filter((t) => {
        const isName = Boolean(String(t?.name || '').toLowerCase().includes(search));
        const isSynonyms = Boolean((t?.synonymsList || []).find((t) => String(t || '').includes(search)))

        return Boolean(isName || isSynonyms)
      })
    },

    selectedCountryName: function () {
      return this.country?.name || this.$t('partnerCalculatorBlock.country')
    }
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        window.addEventListener('click', this.eventClick, true);
      } else {
        window.removeEventListener('click', this.eventClick, true);
      }
    },
    service: function () {
      this.items = [];
      this.search = "";
      this.isLoading = true;
    },
  },

  methods: {
    eventClick: function (event) {
      if (event.target.closest('.account-shop-filter-country')) {
        return
      }
      this.isOpen = false;
    },

    changeOpen: async function () {
      let isOpen = !this.isOpen;
      this.isOpen = isOpen;

      if (isOpen && this.isLoading === true) {
        await this.getItems();
      }
    },
    getItems: async function () {
      const search = [
        Boolean(this.service?.external_id) && `service=${ this.service?.external_id }`
      ].filter((t) => !!t).join('&');
      const res = await this.$api.agent.transport.get(['/ready-accounts/countries-list', search].filter((t) => !!t).join('?'))
        .then((res) => res?.data || [])
        .catch(() => []);
      const items = [...(res || [])].map((item) => {
        const synonymsString = item?.synonyms || "";
        let synonymsList = [];
        if (synonymsString) {
          try {
            synonymsList = String(String(synonymsString || '')).split(' ').filter((t) => !!t).map((t) => String(t || '').toLocaleLowerCase() || '')
          } catch (err) {}
        }

        return {
          ...item,
          synonymsList
        }
      });

      this.items = items;
      this.isLoading = false;
    },
    selectCountry: function (country) {
      this.$emit("change", country);
      this.isOpen = false;
    },
  }
}
